import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { TRADES_QUERY_KEY } from "./useTrades";

type Body = components["schemas"]["BulkTradeIdsBody"];
type Response = components["schemas"]["BulkTradesResponse"];

export function useBulkSoftDeleteTrades() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<Response, Error, Body>({
    mutationFn: async (body) => {
      const { data, error } = await client.POST("/api/trades/bulk/delete", { body });
      if (error !== undefined) {
        throw new Error("Failed to soft-delete selected trades");
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TRADES_QUERY_KEY });
    },
  });
}
